import { useState } from "react";
import "../Styles/Wardrobe.css";

import LeftArrow from "./LeftArrow";
import RightArrow from "./RightArrow";

const Wardrobe = (props) => {
  return (
    <div className="wardrobe-container">
      <p className="wardrobe-header-text">{props.text}</p>

      <div className="carousel-container">
        <LeftArrow setClothes={props.setClothes} />
        {props.clothes.map((cloth, index) => (
          <div key={index} className={`carousel-item cloth${index}`}>
            <img src={cloth.src} className="centered-img" data-id={cloth.id} />
          </div>
        ))}
        <RightArrow setClothes={props.setClothes} />
      </div>

      {/* <div>Selected: {props.clothes[1]}</div> */}
    </div>
  );
};

export default Wardrobe;
